import "./App.css";
import { BrowserRouter, HashRouter, Route, Routes } from "react-router-dom";
import { Suspense, React } from "react";
import Login from "./Pages/Login/index.tsx";
import DashBoard from "./Pages/admin/Dashboard/index.tsx";
import MainLayout from "./component/MainLayout/index.tsx";
import History from "./Pages/History/index.tsx";
import RequestCoupon from "./Pages/RequestCouon/index.tsx";
import ListUserRegisted from "./Pages/admin/ListUserRegister/index.tsx";
import Customer from "./Pages/admin/customer/index.tsx";
import EditUser from "./Pages/admin/editUser/index.tsx";
import ListBranch from "./Pages/admin/list-branch/index.tsx";
import AddBranch from "./Pages/admin/add-branch/index.tsx";
import Frame from "./Pages/admin/list-frame/index.tsx";
import AddFrame from "./Pages/admin/add-frame/index.tsx";
import ListCategory from "./Pages/admin/list-category-frame/index.tsx";
import AddCategory from "./Pages/admin/add-category-frame/index.tsx";
import ListEvent from "./Pages/admin/list-event/index.tsx";
import AddEvent from "./Pages/admin/add-event/index.tsx";
import ListBanner from "./Pages/admin/list-banner/index.tsx";
import AddBanner from "./Pages/admin/add-banner/index.tsx";
import { useSelector } from "react-redux";
import { authSelect } from "./store/slice/auth.slice.tsx";
import HistoryStaffRequest from "./Pages/admin/HistoryStaffRequest/index.tsx";
import DetailRequestCouon from "./Pages/admin/DetailRequestCouon/index.tsx";
import CaptureCount from "./Pages/admin/capture-count/index.tsx";
import Thongke from "./Pages/admin/Thongke.tsx";
import Device from "./Pages/admin/device/index.tsx";
import AddDevice from "./Pages/admin/AddDevice/index.tsx";
import ListPopups from "./Pages/admin/list-popups/index.tsx";
import AddPopups from "./Pages/admin/add-popups/index.tsx";
import CreateAccountCoupon from "./Pages/admin/coupon/CreateAccountCoupon.tsx";
import CouponEmployee from "./Pages/admin/coupon/CouponEmployee.tsx";
import AddListFrame from "./Pages/admin/add-list-frame/AddListFrame.tsx";
import UpdateStatusFrame from "./Pages/admin/add-list-frame/UpdateStatusFrame.tsx";
import CheckCoupon from "./Pages/admin/coupon/CheckCoupon.tsx";
import CheckUserScanQR from "./Pages/admin/coupon/CheckUserScanQR.tsx";
import CreateCouponForUser from "./Pages/admin/coupon/CreateCouponForUser.tsx";
import CreateOtp from "./Pages/admin/otp/CreateOtp.tsx";
import Contact from "./Pages/admin/contact/index.tsx";
import CreateNews from "./Pages/admin/add-news/index.tsx";
import News from "./Pages/admin/list-news/index.tsx";
import ContentLandingPage from "./Pages/admin/list-content-landing-page/index.tsx";
import CreateContentLandingPage from "./Pages/admin/add-content-landing-page/index.tsx";
import NotificationPage from "./Pages/admin/notification/index.tsx";
import StudentNotificationPage from "./Pages/admin/student-notification/index.tsx";
import StatusTransactionPage from "./Pages/StatusTransaction/index.tsx";
function App() {
  const loading = false;
  const { userInfo } = useSelector(authSelect);
  // const dataNav = userInfo?.role === "ADMIN" ? dataRouteAdmin : dataRouteStaff;
  return (
    <BrowserRouter>
      <Suspense fallback={loading}>
        <Routes>
          <Route exact path="/" name="Login Page" element={<Login />} />

          {userInfo?.role === "STAFF" ? (
            <>
              <Route
                exact
                path="/requestCoupon"
                name="Request Coupon"
                element={
                  <MainLayout>
                    <RequestCoupon />
                  </MainLayout>
                }
              />
              <Route
                exact
                path="/staff/customer"
                name="Customer"
                element={
                  <MainLayout>
                    <Customer />
                  </MainLayout>
                }
              />
              <Route
                exact
                path="/history"
                name="History"
                element={
                  <MainLayout>
                    <History />
                  </MainLayout>
                }
              />
              <Route
                exact
                path="/admin/detail-request-couon"
                name="add banner"
                element={
                  <MainLayout>
                    <DetailRequestCouon />
                  </MainLayout>
                }
              />
              <Route
                exact
                path="/admin/editUser"
                name="Customer"
                element={
                  <MainLayout>
                    <EditUser />
                  </MainLayout>
                }
              />
              <Route
                exact
                path="/admin/status-transaction"
                name="StatusTransaction"
                element={
                  <MainLayout>
                    <StatusTransactionPage />
                  </MainLayout>
                }
              />
            </>
          ) : userInfo?.role === "ADMIN" ? (
            <>
              <Route
                exact
                path="/dashboard"
                name="Dashboard"
                element={
                  <MainLayout>
                    <DashBoard />
                  </MainLayout>
                }
              />
              <Route
                exact
                path="/admin/ListUserRegisted"
                name="List User Register"
                element={
                  <MainLayout>
                    <ListUserRegisted />
                  </MainLayout>
                }
              />

              <Route
                exact
                path="/admin/customer"
                name="Customer"
                element={
                  <MainLayout>
                    <Customer />
                  </MainLayout>
                }
              />
              <Route
                exact
                path="/admin/editUser"
                name="Customer"
                element={
                  <MainLayout>
                    <EditUser />
                  </MainLayout>
                }
              />

              <Route
                exact
                path="/admin/branch"
                name="List Branch"
                element={
                  <MainLayout>
                    <ListBranch />
                  </MainLayout>
                }
              />

              <Route
                exact
                path="/admin/add-branch"
                name="add branch"
                element={
                  <MainLayout>
                    <AddBranch />
                  </MainLayout>
                }
              />

              <Route
                exact
                path="/admin/frame"
                name="List Frame"
                element={
                  <MainLayout>
                    <Frame />
                  </MainLayout>
                }
              />

              <Route
                exact
                path="/admin/add-frame"
                name="add branch"
                element={
                  <MainLayout>
                    <AddFrame />
                  </MainLayout>
                }
              />

              <Route
                exact
                path="/admin/frame-category"
                name="List Category"
                element={
                  <MainLayout>
                    <ListCategory />
                  </MainLayout>
                }
              />

              <Route
                exact
                path="/admin/add-category"
                name="add branch"
                element={
                  <MainLayout>
                    <AddCategory />
                  </MainLayout>
                }
              />
              {/* <Route
                exact
                path="/admin/frames"
                name="capture count"
                element={
                  <MainLayout>
                    <CaptureCount />
                  </MainLayout>
                }
              /> */}
              <Route
                exact
                path="/admin/list-event"
                name="List Event"
                element={
                  <MainLayout>
                    <ListEvent />
                  </MainLayout>
                }
              />

              <Route
                exact
                path="/admin/add-event"
                name="add Event"
                element={
                  <MainLayout>
                    <AddEvent />
                  </MainLayout>
                }
              />

              <Route
                exact
                path="/admin/list-banner"
                name="List banner"
                element={
                  <MainLayout>
                    <ListBanner />
                  </MainLayout>
                }
              />

              <Route
                exact
                path="/admin/add-banner"
                name="add banner"
                element={
                  <MainLayout>
                    <AddBanner />
                  </MainLayout>
                }
              />

              <Route
                exact
                path="/admin/list-popups"
                name="List banner"
                element={
                  <MainLayout>
                    <ListPopups />
                  </MainLayout>
                }
              />

              <Route
                exact
                path="/admin/add-popups"
                name="add popups"
                element={
                  <MainLayout>
                    <AddPopups />
                  </MainLayout>
                }
              />

              <Route
                exact
                path="/admin/history-staff-request-coupon"
                name="add banner"
                element={
                  <MainLayout>
                    <HistoryStaffRequest />
                  </MainLayout>
                }
              />

              <Route
                exact
                path="/admin/detail-request-couon"
                name="add banner"
                element={
                  <MainLayout>
                    <DetailRequestCouon />
                  </MainLayout>
                }
              />
              <Route
                exact
                path="/admin/thong-ke"
                name="ThongKe"
                element={<Thongke />}
              />
              <Route
                exact
                path="/admin/list-device"
                name="Device"
                element={
                  <MainLayout>
                    <Device />
                  </MainLayout>
                }
              />
              <Route
                exact
                path="/admin/add-device"
                name="Add Device"
                element={
                  <MainLayout>
                    <AddDevice />
                  </MainLayout>
                }
              />
              <Route
                exact
                path="/admin/create-account-coupon"
                name="CreateAccountCoupon"
                element={
                  <MainLayout>
                    <CreateAccountCoupon />
                  </MainLayout>
                }
              />
              <Route
                exact
                path="/admin/create-coupon-user"
                name="CreateCouponForUser"
                element={
                  <MainLayout>
                    <CreateCouponForUser />
                  </MainLayout>
                }
              />
              <Route
                exact
                path="/admin/check-coupon"
                name="CheckCoupon"
                element={
                  <MainLayout>
                    <CheckCoupon />
                  </MainLayout>
                }
              />
              <Route
                exact
                path="/admin/check-user-scan-qr-code"
                name="CheckUserScanQrCode"
                element={
                  <MainLayout>
                    <CheckUserScanQR />
                  </MainLayout>
                }
              />
              <Route
                exact
                path="/admin/coupon-employee"
                name="CouponEmployee"
                element={
                  <MainLayout>
                    <CouponEmployee />
                  </MainLayout>
                }
              />
              <Route
                exact
                path="/admin/add-list-frame"
                name="AddListFrame"
                element={
                  <MainLayout>
                    <AddListFrame />
                  </MainLayout>
                }
              />
              <Route
                exact
                path="/admin/update-status-frame"
                name="AddListFrame"
                element={
                  <MainLayout>
                    <UpdateStatusFrame />
                  </MainLayout>
                }
              />
              <Route
                exact
                path="/admin/update-status-frame"
                name="AddListFrame"
                element={
                  <MainLayout>
                    <CreateAccountCoupon />
                  </MainLayout>
                }
              />
              <Route
                exact
                path="/admin/create-otp"
                name="CreateOTP"
                element={
                  <MainLayout>
                    <CreateOtp />
                  </MainLayout>
                }
              />
              <Route
                exact
                path="/admin/contact"
                name="Contact"
                element={
                  <MainLayout>
                    <Contact />
                  </MainLayout>
                }
              />
              <Route
                exact
                path="/admin/create-news"
                name="CreateNews"
                element={
                  <MainLayout>
                    <CreateNews />
                  </MainLayout>
                }
              />
              <Route
                exact
                path="/admin/list-news"
                name="ListNews"
                element={
                  <MainLayout>
                    <News/>
                  </MainLayout>
                }
              /><Route
                exact
                path="/admin/content-landing-page"
                name="ContentLandingPage"
                element={
                  <MainLayout>
                    <CreateContentLandingPage/>
                  </MainLayout>
                }
              />
              <Route
                exact
                path="/admin/content-landing-page-list"
                name="ContentLandingPageList"
                element={
                  <MainLayout>
                    <ContentLandingPage/>
                  </MainLayout>
                }
              />
              
              <Route
                exact
                path="/admin/notification"
                name="Notification"
                element={
                  <MainLayout>
                    <NotificationPage/>
                  </MainLayout>
                }
              />
              
              <Route
                exact
                path="/admin/noti-students"
                name="NotificationStudent"
                element={
                  <MainLayout>
                    <StudentNotificationPage/>
                  </MainLayout>
                }
              />
              <Route
                exact
                path="/admin/status-transaction"
                name="StatusTransaction"
                element={
                  <MainLayout>
                    <StatusTransactionPage />
                  </MainLayout>
                }
              />
            </>
          ) : null}
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
